import { Footer } from '~shared/ui/footer';
import { Screen } from '~shared/ui/screen';

import { Typography } from '@breezeventures/ui-kit/typography';

import WavingManIcon from './icons/waving-man.svg?react';

import { PersonFormHeader } from '../../../person-form-header';

type StartScreenProps = {
  onSubmit: () => void;
};

export const StartScreen = ({ onSubmit }: StartScreenProps) => {
  return (
    <Screen
      header={<PersonFormHeader />}
      footer={<Footer submitButtonText="Next" onSubmit={onSubmit} />}
    >
      <div className="my-auto flex flex-col items-center">
        <WavingManIcon className="h-55 w-55 shrink-0" />

        <div className="mt-8 flex flex-col items-center gap-3 px-4 text-center">
          <Typography.Title size="s" className="px-2">
            Tell us about yourself, <span className="text-accent-1">boss!</span>
          </Typography.Title>
          <Typography.Text size="m" color="secondary">
            To continue, make sure you&apos;re the business owner and
            the&nbsp;same person listed as the owner in&nbsp;the&nbsp;official
            business&nbsp;documents. If approved, you&apos;ll sign
            the&nbsp;agreement using an&nbsp;OTP sent to your registered
            mobile&nbsp;number.
          </Typography.Text>
        </div>
      </div>
    </Screen>
  );
};
